import React, { useEffect, useRef, useState } from "react";
import { LayoutHome } from "../LayoutHome";
import { useParams } from "react-router-dom";
import { notification, Input, Button, Flex } from "antd";
import { Col, Panel, Row, Text, SelectPicker, Checkbox } from "rsuite";
import { getListPacientes } from "../Services/PacientesServices";
import { Eraser, LucideSignature, LucideZoomIn } from "lucide-react";
import SignatureCanvas from "react-signature-canvas";
import { isEmpty } from "lodash";

import {
  getConsentimientos,
  saveAvisoPriv,
  saveConsentHemo,
  saveFirmaMedico,
  saveAplicaHierro,
} from "../Services/PacientesServices";
import moment from "moment/moment";

export const FirmaConsentimiento = () => {
  const validaSession = JSON.parse(localStorage.getItem("auth"));
  if (validaSession === null) {
    window.location = `/#/App`;
  }
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const fechaLarga = JSON.parse(localStorage.getItem("auth")).confApp.fechas
    .fechaLarga;
  const [idMedicoSesion] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const medicoSesion = JSON.parse(localStorage.getItem("auth")).nombre;

  const [time, setTime] = useState(new Date());
  const [fechaFirma, setFechaFirma] = useState("");
  const [estatus, setEstatus] = useState("");
  const [idPaciente, setIdPaciente] = useState("");
  const [paciente, setPaciente] = useState("");
  const [medico, setMedico] = useState("");
  const [dataPacientes, setDataPacientes] = useState([]);
  const [firma, setFirma] = useState("");
  const [firmaTestigo1, setFirmaTestigo1] = useState("");
  const [firmaTestigo2, setFirmaTestigo2] = useState("");
  const [tituloCanvas, setTituloCanvas] = useState("Firma del Paciente");
  const [esTutor, setEsTutor] = useState(0);
  const [tutor, setTutor] = useState("");
  const [nomTestigo1, setNomTestigo1] = useState("");
  const [nomTestigo2, setNomTestigo2] = useState("");

  const [step, setStep] = useState(0);
  const [orderStatus, setOrderStatus] = React.useState("Processing");

  const { documento } = useParams();
  const initialized = useRef(false);

  const [api, contextHolder] = notification.useNotification();
  const signCanvas = useRef({});
  const pad1Ref = useRef({});
  const pad2Ref = useRef({});

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const clear = () => signCanvas.current.clear();
  const clear1 = () => pad1Ref.current.clear();
  const clear2 = () => pad2Ref.current.clear();

  const saveSignature = () => {
    let firmaPaciente = "";
    let testigo1 = "";
    let testigo2 = "";

    if (signCanvas.current) {
      firmaPaciente = signCanvas.current.toDataURL("image/png");
      setFirma(firmaPaciente);
    }

    if (!isEmpty(pad1Ref.current)) {
      testigo1 = pad1Ref.current.toDataURL("image/png");
      setFirmaTestigo1(testigo1);
    }
    if (!isEmpty(pad2Ref.current)) {
      testigo2 = pad2Ref.current.toDataURL("image/png");
      setFirmaTestigo2(testigo2);
    }

    if (nomTestigo1 === "") {
      testigo1 = "";
    }
    if (nomTestigo2 === "") {
      testigo2 = "";
    }

    if (signCanvas.current.isEmpty()) {
      errorNotificaction(
        "Sin firmar",
        "La firma del paciente no puede estar vacia.",
      );
      return;
    }

    if (documento === "Aviso de Privacidad") {
      saveAviso(firmaPaciente, testigo1, testigo2);
    }
    if (documento === "Hemodiálisis") {
      saveFirmaConsent(firmaPaciente, testigo1, testigo2);
    }
    if(documento === "Aplicación de Hierro"){
      saveFirmaAplicaHierro(firmaPaciente, testigo1, testigo2);
    }
  };

  const saveAviso = async (firmaPac, firmaTest1, firmaTest2) => {
    const data = {
      id: idNegocio,
      idPac: idPaciente,
      firma: firmaPac,
    };

    await saveAvisoPriv(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Firma",
            "Se ha registrado la firma del paciente",
          );
          setTimeout(() => {
            window.location.reload();
          }, 1200);
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const saveFirmaConsent = async (firmaPac, firmaTest1, firmaTest2) => {
    if (documento === "Hemodiálisis" && nomTestigo1 === "") {
      errorNotificaction("Error", "Debes escribir el nombre del Testigo (1)");
      return;
    }
    if (documento === "Hemodiálisis" && esTutor === 1 && tutor === "") {
      errorNotificaction("Error", "Debes escribir el nombrte del Tutor");
      return;
    }

    const data = {
      id: idNegocio,
      idPac: idPaciente,
      idMedico: idMedicoSesion === 0 ? null : idMedicoSesion,
      firma: firmaPac,
      tutor: tutor,
      firmaTestigo1: firmaTest1,
      nomTestigo1: nomTestigo1,
      firmaTestigo2: firmaTest2,
      nomTestigo2: nomTestigo2,
      step: step,
    };

    await saveConsentHemo(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Firma",
            "Se ha registrado la firmado el consentimiento de forma corretca.",
          );
          setTimeout(() => {
            window.location.reload();
          }, 1200);
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const saveFirmaAplicaHierro = async (firmaPac, firmaTest1, firmaTest2) => {
    if (documento === "Aplicación de Hierro" && nomTestigo1 === "") {
      errorNotificaction("Error", "Debes escribir el nombre del Testigo (1)");
      return;
    }
    if (documento === "Aplicación de Hierro" && esTutor === 1 && tutor === "") {
      errorNotificaction("Error", "Debes escribir el nombrte del Tutor");
      return;
    }

    const data = {
      id: idNegocio,
      idPac: idPaciente,
      idMedico: idMedicoSesion === 0 ? null : idMedicoSesion,
      firma: firmaPac,
      tutor: tutor,
      firmaTestigo1: firmaTest1,
      nomTestigo1: nomTestigo1,
      firmaTestigo2: firmaTest2,
      nomTestigo2: nomTestigo2,
      step: step,
    };

    await saveAplicaHierro(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Firma",
            "Se ha registrado la firmado el consentimiento de forma corretca.",
          );
          setTimeout(() => {
            window.location.reload();
          }, 1200);
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const existeFirmaPac = async (e) => {
    if (e === null) {
      setIdPaciente("");
      setPaciente("");
      setFechaFirma("");
      setEstatus("");
      return;
    }

    const selectedItem = dataPacientes.find((item) => item.value === e);
    setIdPaciente(e);
    setPaciente(selectedItem.label);

    await getConsentimientos(idNegocio, e, documento)
      .then((res) => {
        if (res.fecha !== null) {
          setFechaFirma(moment(res.fecha).format("LLLL"));
        } else {
          setFechaFirma("");
        }
        setEstatus(res.estatus);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleCheck = (e) => {
    if (e) {
      setEsTutor(1);
      setTituloCanvas("Firma del Tutor");
    } else {
      setEsTutor(0);
      setTituloCanvas("Firma del Paciente");
    }
  };

  const saveFirmaConsentMedico = async () => {
    let doc = 'Consent';
    if(documento !== 'Hemodiálisis'){ doc = 'AplicaHierro'; }
    
    const data = {
      id: idNegocio,
      idMedico: idMedicoSesion,
      idPaciente: idPaciente,
      doc: doc,
    };
    await saveFirmaMedico(data).then((res) => {
      if (res.data > 0) {
        successNotification(
          "Firma",
          "El documento se ha firmado por el médico en sesión.",
        );
      } else {
        errorNotificaction("Error", "Ocurrio un error al grabar la firma");
      }
    });
  };

  const loadPacientes = async (e) => {
    if (e === null) {
      setDataPacientes([]);
      return;
    }

    await getListPacientes(idNegocio)
      .then((res) => {
        setDataPacientes(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const showDocumento = () => {
    if (documento === "Aviso de Privacidad") {
      window.open(
        `/#/App/Home/FirmaConsentimiento/AvisoPrivacidad/${idPaciente}/${paciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
    if (documento === "Hemodiálisis") {
      window.open(
        `/#/App/Home/FirmaConsentimiento/ConsentHemo/${idPaciente}/${paciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
    if (documento === "Aplicación de Hierro") {
      window.open(
        `/#/App/Home/FirmaConsentimiento/AplicacionHierro/${idPaciente}/${paciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadPacientes().then((res) => {
        // 2. Set up a timer to update state every second (1000ms)
        const timerId = setInterval(() => {
          setTime(new Date());
        }, 1000);

        // 3. Clean up the interval when the component unmounts to prevent memory leaks
        return () => clearInterval(timerId);
      });
    }
  }, []);

  return (
    <div>
      <title>Firma de Consentimiento</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: `Firma de Consentimiento (${documento})` },
        ]}
        selectedKey={"FirmaConsentimiento"}
      >
        {contextHolder}
        <center><Text size={"2xl"}>Firma de Consentimiento ({documento})</Text></center>
        <Panel bordered>
          <Row gutter={20}>
            <Col span={12}>
              <Text weight="semibold">Nombre del paciente</Text>
              <SelectPicker
                block
                value={idPaciente}
                data={dataPacientes}
                placeholder="-- SELECCIONA --"
                onChange={(e) => existeFirmaPac(e)}
              />
            </Col>
            <Col span={8}>
              <Text weight="semibold" color={"red.500"}>
                Documento firmado
              </Text>
              <Input readOnly variant="underlined" value={fechaFirma} />
            </Col>
            <Col span={2}>
              <br></br>
              <Button
                type="primary"
                icon={<LucideZoomIn size={16}></LucideZoomIn>}
                disabled={fechaFirma !== "" ? false : true}
                onClick={showDocumento}
              >
                Mostrar
              </Button>
            </Col>
          </Row>
        </Panel>
        {idMedicoSesion > 0 ? (
          <Panel bordered>
            <Row gutter={20}>
              <Col span={10}>
                <Text weight="semibold">Médico</Text>
                <Input readOnly variant="underlined" value={medicoSesion} />
              </Col>
              <Col span={2}>
                <br></br>
                <Button
                  type="primary"
                  disabled={
                    idPaciente === "" || fechaFirma === "" ? true : false
                  }
                  icon={<LucideSignature size={16}></LucideSignature>}
                  onClick={saveFirmaConsentMedico}
                >
                  Firmar
                </Button>
              </Col>
            </Row>
          </Panel>
        ) : (
          ""
        )}
        <br></br>
        {idMedicoSesion === 0 ? (
          <Panel
            header={
              <Text>
                Fecha y Hora de la Firma: {fechaLarga}{" "}
                {time.toLocaleTimeString()}
              </Text>
            }
            bordered
          >
            <Row gutter={20} style={{ paddingBottom: "10px" }}>
              <Col span={6} style={{ textAlign: "center" }}>
                {documento === "Hemodiálisis" ? (
                  <Checkbox
                    onClick={(e) => handleCheck(e.target.checked)}
                    style={{ fontSize: "16px" }}
                  >
                    Es Tutor
                  </Checkbox>
                ) : (
                  ""
                )}
              </Col>
              <Col
                span={12}
                style={{ borderWidth: "thin", border: "solid  1px" }}
              >
                <Text size={"md"} color={"black"}>
                  {tituloCanvas}
                </Text>
                <SignatureCanvas
                  ref={signCanvas}
                  canvasProps={{
                    style: { width: "100%", minHeight: "220px" },
                  }}
                />
                {esTutor === 1 ? (
                  <Input
                    variant="underlined"
                    placeholder="ESCRIBA AQUÍ EL NOMBRE DEL TUTOR"
                    value={tutor}
                    onChange={(e) => setTutor(e.target.value)}
                  />
                ) : (
                  ""
                )}
              </Col>
              <Col span={6}></Col>
            </Row>
            <Row>
              <Flex vertical gap={"small"} style={{ width: "100%" }}>
                <Button
                  icon={<Eraser></Eraser>}
                  type="default"
                  variant="solid"
                  onClick={clear}
                  block
                >
                  Borrar
                </Button>
              </Flex>
            </Row>
          </Panel>
        ) : (
          ""
        )}

        {(documento === "Hemodiálisis" || documento === 'Aplicación de Hierro') && idMedicoSesion === 0 ? (
          <>
            <br></br>
            <Panel
              header={
                <Text>
                  Fecha y Hora de la Firma: {fechaLarga}{" "}
                  {time.toLocaleTimeString()}
                </Text>
              }
              bordered
            >
              <Row gutter={20} style={{ paddingBottom: "10px" }}>
                <Col span={6} style={{ textAlign: "center" }}></Col>
                <Col
                  span={12}
                  style={{ borderWidth: "thin", border: "solid  1px" }}
                >
                  <Text size={"md"} color={"black"}>
                    Firma del Testigo 1
                  </Text>
                  <SignatureCanvas
                    ref={pad1Ref}
                    canvasProps={{
                      style: { width: "100%", minHeight: "220px" },
                    }}
                  />
                  <Input
                    variant="underlined"
                    placeholder="ESCRIBA AQUÍ EL NOMBRE DEL TESTIGO 1"
                    value={nomTestigo1}
                    onChange={(e) => setNomTestigo1(e.target.value)}
                  />
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row>
                <Flex vertical gap={"small"} style={{ width: "100%" }}>
                  <Button
                    icon={<Eraser></Eraser>}
                    type="default"
                    variant="solid"
                    onClick={clear1}
                    block
                  >
                    Borrar
                  </Button>
                </Flex>
              </Row>
            </Panel>
            <br></br>
            <Panel
              header={
                <Text>
                  Fecha y Hora de la Firma: {fechaLarga}{" "}
                  {time.toLocaleTimeString()}
                </Text>
              }
              bordered
            >
              <Row gutter={20}>
                <Col span={6} style={{ textAlign: "center" }}></Col>
                <Col
                  span={12}
                  style={{ borderWidth: "thin", border: "solid  1px" }}
                >
                  <Text size={"md"} color={"black"}>
                    Firma del Testigo 2
                  </Text>
                  <SignatureCanvas
                    ref={pad2Ref}
                    canvasProps={{
                      style: { width: "100%", minHeight: "220px" },
                    }}
                  />
                  <Input
                    variant="underlined"
                    placeholder="ESCRIBA AQUÍ EL NOMBRE DEL TESTIGO 2"
                    value={nomTestigo2}
                    onChange={(e) => setNomTestigo2(e.target.value)}
                  />
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row>
                <Flex vertical gap={"small"} style={{ width: "100%" }}>
                  <Button
                    icon={<Eraser></Eraser>}
                    type="default"
                    variant="solid"
                    onClick={clear2}
                    block
                  >
                    Borrar
                  </Button>
                </Flex>
              </Row>
            </Panel>
          </>
        ) : (
          ""
        )}
        <br></br>
        {idMedicoSesion === 0 ? (
          <Row>
            <Flex vertical gap={"small"} style={{ width: "100%" }}>
              <Button
                type="primary"
                icon={<LucideSignature size={16}></LucideSignature>}
                disabled={
                  idPaciente !== ""
                    ? idMedicoSesion === 0
                      ? false
                      : true
                    : true
                }
                block
                onClick={saveSignature}
              >
                Firmar documento
              </Button>
            </Flex>
          </Row>
        ) : (
          ""
        )}
      </LayoutHome>
    </div>
  );
};
